<template>
  <div>

    <div v-if="site">

      <h1 style="font-weight: 500;">
        {{ potential_site.handle }}
        <span style="font-size:0.5em; padding-left:20px; " :style="{ color: potential_site.approval_state_color }">{{ potential_site.approval_state_name }}</span>
      </h1>

      <fieldset>
        <label>Weighting</label>
        <div class="admin__columns">
           <input type="number" v-model.number="weighting"  />
           <a class="admin__button admin__button--inline" @click="saveWeighting__clicked">Save Weighting</a>
        </div>
      </fieldset>

      <fieldset>
        <label>Main Image Index</label>
        <input type="number" v-model="potential_site.main_image_index"  />
      </fieldset>

      <h3>Product Type to Category Mappings</h3>
      <table style="margin-top:24px;">
        <tr v-for="(mapping, mapping_index) in product_type_mappings" :key="mapping_index">
          <td style="white-space: nowrap">{{ mapping.value }}</td>

          <td style="white-space: nowrap">
            to:
          </td>
          <td>
            <select v-model="product_type_mappings[mapping_index].category_object" >
              <option v-for="(category, category_index) in categories" :key="category_index" :value="category">{{ category.title }}</option>
            </select>
          </td>

          <td>
            <select v-model="product_type_mappings[mapping_index].display_state" :data-display-state="mapping.display_state">
              <option v-for="display_state in display_states" :value="display_state.value">{{ display_state.name }}</option>
            </select>
          </td>
        </tr>
      </table>

      <div class="admin__actions" style="margin-top: 10px">
       <!-- <a class="button" @click="addCategoryMapping__clicked">Add New Category Mapping</a> -->
        <a class="button" @click="saveCategoryMapping__clicked">Save Category Mappings</a>
        <a class="button" @click="updateProductsCategories__clicked">Update Products Categories</a>
      </div>




      <h3>Collection to Category Mappings</h3>

      <table style="margin-top:24px;">
        <tr v-for="(mapping, mapping_index) in collection_mappings" :key="mapping_index">
          <td style="white-space: nowrap">
            <a :href="`https://${potential_site.domain_url}/collections/${ mapping.value }`" target="_blank">
              {{ mapping.value }}
            </a>
          </td>

          <td style="white-space: nowrap">
            to:
          </td>
          <td>
            <select v-model="collection_mappings[mapping_index].category_object" >
              <option v-for="(category, category_index) in categories" :key="category_index" :value="category">{{ category.title }}</option>
            </select>
          </td>

          <td>
            <select v-model="collection_mappings[mapping_index].display_state" :data-display-state="mapping.display_state">
              <option v-for="display_state in display_states" :value="display_state.value">{{ display_state.name }}</option>
            </select>
          </td>
        </tr>
      </table>


      <div class="admin__actions" style="margin-top: 10px">
        <a class="button" @click="saveCategoryMapping__clicked">Save Category Mappings</a>
        <a class="button" @click="updateProductsCategories__clicked">Update Products Categories</a>
        <a class="button" @click="importShopifyCollections__clicked">Import Shopify Collections</a>
        <a class="button" @click="test__clicked">Test</a>
      </div>


      <!--
      <h3>Product Types</h3>
      <div class="admin__columns" style="flex-wrap: wrap;">
        <div style="flex: 0 0 33%;" v-for="(product_type, index) in potential_site.product_types" :key="index">{{ product_type }}</div>
      </div>
      -->


      <h3>Site Data</h3>
      <table class="admin__table">
        <tr><td class="admin__table-heading">ShopifySite Document ID</td><td>{{ site.document_id }}</td></tr>
        <tr><td class="admin__table-heading">PotentialShopifySite Document ID</td><td>{{ site.potential_shopify_site_document_id }}</td></tr>
        <tr><td class="admin__table-heading">Name</td><td>{{ site.name }}</td></tr>
        <tr><td class="admin__table-heading">Handle</td><td>{{ site.handle }}</td></tr>
        <tr><td class="admin__table-heading">Shopify ID</td><td>{{ site.shopify_id }}</td></tr>
        <tr><td class="admin__table-heading">Api Url</td><td>{{ site.api_url }}</td></tr>
        <tr><td class="admin__table-heading">Domain</td><td>{{ site.domain }}</td></tr>
        <tr><td class="admin__table-heading">MyShopify Domain</td><td>{{ site.myshopify_domain }}</td></tr>
        <tr><td class="admin__table-heading">Country</td><td>{{ site.country }}</td></tr>
        <tr><td class="admin__table-heading">Currency</td><td>{{ site.currency }}</td></tr>
        <tr><td class="admin__table-heading">Currency Symbol</td><td>{{ site.currency_symbol }}</td></tr>
        <tr><td class="admin__table-heading">Description</td><td>{{ site.description }}</td></tr>
        <tr><td class="admin__table-heading">Ships To Countries</td><td>{{ site.ships_to_countries }}</td></tr>
        <tr><td class="admin__table-heading">Approved At</td><td>{{ site.approved_at.toDate() }}</td></tr>
      </table>
    </div>

    <h3>Potential Site Data</h3>
    <table class="admin__table">
      <tr><td class="admin__table-heading">ShopifySite Document ID</td><td>{{ potential_site.shopify_site_document_id  }}</td></tr>
      <tr><td class="admin__table-heading">PotentialShopifySite Document ID</td><td>{{ potential_site.document_id }}</td></tr>
      <tr><td class="admin__table-heading">Domain</td><td>{{ potential_site.domain }}</td></tr>
      <tr><td class="admin__table-heading">Domain Url</td><td>{{ potential_site.domain_url }}</td></tr>
      <tr><td class="admin__table-heading">Approval State</td><td :style="{ color: potential_site.approval_state_color }">{{ potential_site.approval_state_name }}</td></tr>
      <tr><td class="admin__table-heading"></td><td></td></tr>
      <tr><td class="admin__table-heading"></td><td></td></tr>
      <tr><td class="admin__table-heading">Name</td><td>{{ potential_site.name }}</td></tr>
      <tr><td class="admin__table-heading">Handle</td><td>{{ potential_site.handle }}</td></tr>
      <tr><td class="admin__table-heading">Shopify ID</td><td>{{ potential_site.shopify_id }}</td></tr>
      <tr><td class="admin__table-heading">Shopify Name</td><td>{{ potential_site.shopify_name }}</td></tr>
      <tr><td class="admin__table-heading">Shopify City</td><td>{{ potential_site.shopify_city }}</td></tr>
      <tr><td class="admin__table-heading">Shopify Province</td><td>{{ potential_site.shopify_province }}</td></tr>
      <tr><td class="admin__table-heading">Shopify Country</td><td>{{ potential_site.shopify_country }}</td></tr>
      <tr><td class="admin__table-heading">Shopify Currency</td><td>{{ potential_site.shopify_currency }}</td></tr>
      <tr><td class="admin__table-heading">Shopify Domain</td><td>{{ potential_site.shopify_domain }}</td></tr>
      <tr><td class="admin__table-heading">API URL</td><td>{{ potential_site.api_url }}</td></tr>
      <tr><td class="admin__table-heading">Shopify Url</td><td>{{ potential_site.shopify_url }}</td></tr>
      <tr><td class="admin__table-heading">Shopify MyShopify Domain</td><td>{{ potential_site.shopify_myshopify_domain }}</td></tr>
      <tr><td class="admin__table-heading">Shopify Description</td><td>{{ potential_site.shopify_description }}</td></tr>
      <tr><td class="admin__table-heading">Shopify Ships To Countries</td><td>{{ potential_site.shopify_ships_to_countries }}</td></tr>
      <tr><td class="admin__table-heading">Shopify Money Format</td><td>{{ potential_site.shopify_money_format }}</td></tr>
      <tr><td class="admin__table-heading">Shopify Collections Count</td><td>{{ potential_site.shopify_published_collections_count }}</td></tr>
      <tr><td class="admin__table-heading">Shopify Proudcts Count</td><td>{{ potential_site.shopify_published_products_count }}</td></tr>
      <tr><td class="admin__table-heading">Shopify Supported Payments</td><td>{{ potential_site.shopify_shopify_pay_enabled_card_brands }}</td></tr>
      <tr><td class="admin__table-heading">Shopify Site Doc ID</td><td>{{ potential_site.shopify_site_document_id }}</td></tr>
      <tr><td class="admin__table-heading"></td><td></td></tr>
      <tr><td class="admin__table-heading"></td><td></td></tr>
      <tr><td class="admin__table-heading">alexa rank</td><td>{{ potential_site.alexa_rank }}</td></tr>
      <tr><td class="admin__table-heading">aliases</td><td>{{ potential_site.aliases }}</td></tr>
      <tr><td class="admin__table-heading">approval state</td><td>{{ potential_site.approval_state }}</td></tr>
      <tr><td class="admin__table-heading">categories</td><td>{{ potential_site.categories }}</td></tr>
      <tr><td class="admin__table-heading">city</td><td>{{ potential_site.city }}</td></tr>
      <tr><td class="admin__table-heading">common crawl pagerank</td><td>{{ potential_site.common_crawl_pagerank }}</td></tr>
      <tr><td class="admin__table-heading">company location</td><td>{{ potential_site.company_location }}</td></tr>
      <tr><td class="admin__table-heading">country code</td><td>{{ potential_site.country_code }}</td></tr>
      <tr><td class="admin__table-heading">created</td><td>{{ potential_site.created }}</td></tr>
      <tr><td class="admin__table-heading">currency</td><td>{{ potential_site.currency }}</td></tr>
      <tr><td class="admin__table-heading">document id</td><td>{{ potential_site.document_id }}</td></tr>
      <tr><td class="admin__table-heading">domain</td><td>{{ potential_site.domain }}</td></tr>
      <tr><td class="admin__table-heading">domain tld1</td><td>{{ potential_site.domain_tld1 }}</td></tr>
      <tr><td class="admin__table-heading">domain url</td><td>{{ potential_site.domain_url }}</td></tr>
      <tr><td class="admin__table-heading">emails</td><td>{{ potential_site.emails }}</td></tr>
      <tr><td class="admin__table-heading">estimated monthly sales</td><td>{{ potential_site.estimated_monthly_sales }}</td></tr>
      <tr><td class="admin__table-heading">facebook</td><td>{{ potential_site.facebook }}</td></tr>
      <tr><td class="admin__table-heading">facebook followers</td><td>{{ potential_site.facebook_followers }}</td></tr>
      <tr><td class="admin__table-heading">facebook url</td><td>{{ potential_site.facebook_url }}</td></tr>
      <tr><td class="admin__table-heading">instagram</td><td>{{ potential_site.instagram }}</td></tr>
      <tr><td class="admin__table-heading">instagram followers</td><td>{{ potential_site.instagram_followers }}</td></tr>
      <tr><td class="admin__table-heading">instagram url</td><td>{{ potential_site.instagram_url }}</td></tr>
      <tr><td class="admin__table-heading">installed apps </td><td>{{ potential_site.installed_apps }}</td></tr>
      <tr><td class="admin__table-heading">language code</td><td>{{ potential_site.language_code }}</td></tr>
      <tr><td class="admin__table-heading">monthly app spend</td><td>{{ potential_site.monthly_app_spend }}</td></tr>
      <tr><td class="admin__table-heading">open graph image url</td><td>{{ potential_site.open_graph_image_url }}</td></tr>
      <tr><td class="admin__table-heading">phones</td><td>{{ potential_site.phones }}</td></tr>
      <tr><td class="admin__table-heading">pinterest</td><td>{{ potential_site.pinterest }}</td></tr>
      <tr><td class="admin__table-heading">pinterest followers</td><td>{{ potential_site.pinterest_followers }}</td></tr>
      <tr><td class="admin__table-heading">pinterest url</td><td>{{ potential_site.pinterest_url }}</td></tr>
      <tr><td class="admin__table-heading">plan</td><td>{{ potential_site.plan }}</td></tr>
      <tr><td class="admin__table-heading">platform</td><td>{{ potential_site.platform }}</td></tr>
      <tr><td class="admin__table-heading">platform domain</td><td>{{ potential_site.platform_domain }}</td></tr>
      <tr><td class="admin__table-heading">platform rank</td><td>{{ potential_site.platform_rank }}</td></tr>
      <tr><td class="admin__table-heading">rank</td><td>{{ potential_site.rank }}</td></tr>
      <tr><td class="admin__table-heading">region</td><td>{{ potential_site.region }}</td></tr>
      <tr><td class="admin__table-heading">sales channels</td><td>{{ potential_site.sales_channels }}</td></tr>
      <tr><td class="admin__table-heading">shipping carriers</td><td>{{ potential_site.shipping_carriers }}</td></tr>
      <tr><td class="admin__table-heading">ships to australia</td><td>{{ potential_site.ships_to_australia }}</td></tr>
      <tr><td class="admin__table-heading">ships to europe</td><td>{{ potential_site.ships_to_europe }}</td></tr>
      <tr><td class="admin__table-heading">ships to uk</td><td>{{ potential_site.ships_to_uk }}</td></tr>
      <tr><td class="admin__table-heading">ships to usa</td><td>{{ potential_site.ships_to_usa }}</td></tr>
      <tr><td class="admin__table-heading">state</td><td>{{ potential_site.state }}</td></tr>
      <tr><td class="admin__table-heading">status</td><td>{{ potential_site.status }}</td></tr>
      <tr><td class="admin__table-heading">subregion</td><td>{{ potential_site.subregion }}</td></tr>
      <tr><td class="admin__table-heading">tags</td><td>{{ potential_site.tags }}</td></tr>
      <tr><td class="admin__table-heading">theme</td><td>{{ potential_site.theme }}</td></tr>
      <tr><td class="admin__table-heading">theme spend</td><td>{{ potential_site.theme_spend }}</td></tr>
      <tr><td class="admin__table-heading">theme vendor</td><td>{{ potential_site.theme_vendor }}</td></tr>
      <tr><td class="admin__table-heading">tiktok</td><td>{{ potential_site.tiktok }}</td></tr>
      <tr><td class="admin__table-heading">tiktok followers</td><td>{{ potential_site.tiktok_followers }}</td></tr>
      <tr><td class="admin__table-heading">tiktok url</td><td>{{ potential_site.tiktok_url }}</td></tr>
      <tr><td class="admin__table-heading">title</td><td>{{ potential_site.title }}</td></tr>
      <tr><td class="admin__table-heading">twitter</td><td>{{ potential_site.twitter }}</td></tr>
      <tr><td class="admin__table-heading">twitter followers</td><td>{{ potential_site.twitter_followers }}</td></tr>
      <tr><td class="admin__table-heading">twitter url</td><td>{{ potential_site.twitter_url }}</td></tr>
      <tr><td class="admin__table-heading">vendor count</td><td>{{ potential_site.vendor_count }}</td></tr>
      <tr><td class="admin__table-heading">youtube</td><td>{{ potential_site.youtube }}</td></tr>
      <tr><td class="admin__table-heading">youtube followers</td><td>{{ potential_site.youtube_followers }}</td></tr>
      <tr><td class="admin__table-heading">youtube url</td><td>{{ potential_site.youtube_url }}</td></tr>
    </table>

    <br /> <br />



    <br /> <br />

    <!--
    <fieldset>
      <label>Handle</label>
      <input type="text" v-model="potential_site.handle"  />
    </fieldset>

    <fieldset>
      <label>Verified Domain</label>
      <input type="text" v-model="potential_site.verified_domain"  />
    </fieldset>
    -->



  </div>
</template>


<script>
import PotentialShopifySite from "../../../models/PotentialShopifySite";
import ShopifySite from "../../../models/ShopifySite";
import router from '../../../router/router'
import Category from "../../../models/Category";
import CategoryMapping from "../../../models/CategoryMapping";
import ShopifyProduct from "../../../models/ShopifyProduct";

export default {
  data(){
    return{
      site: null,
      potential_site: {},
      category_mappings: [],
      product_type_mappings: [],
      collection_mappings: [],
      categories: Category.toFlatArray(),
      display_states: ShopifyProduct.DisplayState.toNameValueArray(),
      weighting: 0,
    }
  },
  mounted(){
      this.setSite();
  },
  watch:{
    $route(to, from){
      this.setSite();
    },
  },
  computed:{
    potential_shopify_site_document_id(){
      return this.$route.params.document_id;
    },
  },
  methods: {
    unselected_product_types(current_product_type){
      return this.potential_site.product_types.filter(product_type => (current_product_type == product_type || !this.category_mappings.some(c => c.value == product_type)) )
    },
    async updateProductsCategories__clicked(){
      let updated_count = await ShopifyProduct.updateProductsWithMissingCategories(this.potential_site);
      alert(`${updated_count} Product Categories Updated`);
    },
    addCategoryMapping__clicked(){
      this.category_mappings.push(CategoryMapping.newDefault(this.potential_site));
    },
    async saveCategoryMapping__clicked(event){
      this.potential_site.main_image_index = parseInt(this.potential_site.main_image_index);
      this.potential_site.category_mappings = [
        ...this.collection_mappings.filter(mapping => mapping.category && mapping.subcategory && mapping.display_state).map( mapping => mapping.toData()),
        ...this.product_type_mappings.filter(mapping => mapping.category && mapping.subcategory && mapping.display_state).map( mapping => mapping.toData())
      ];

     // console.log("this.potential_site.category_mappings", this.potential_site.category_mappings)
      await this.potential_site.save();
      alert("Site Saved");


      //this.potential_site.main_image_index = parseInt(this.potential_site.main_image_index);
      //this.potential_site.category_mappings = this.category_mappings.slice(0, 4).map( mapping => mapping.toData() );
      // await this.potential_site.save();
      // alert("Site Saved");
    },
    async saveWeighting__clicked(){
      this.potential_site.weighting = this.weighting;
      await this.potential_site.updateField({ weighting: this.weighting });
    },
    async setSite(){
      this.site = await ShopifySite.getByPotentialShopifySiteId(this.potential_shopify_site_document_id)
      this.potential_site = await PotentialShopifySite.get(this.potential_shopify_site_document_id);
      this.weighting = this.potential_site.weighting ?? 0;
      this.category_mappings = this.potential_site.category_mapping_objects || [];
      //console.log("potential_site", this.potential_site);
     // console.log("mappings", this.category_mappings)

      this.product_type_mappings = this.potential_site.product_types.map(product_type => {
        let empty = CategoryMapping.newEmpty("product_type", product_type);
        let mapping = this.category_mappings.find( mapping => mapping.value == empty.value && mapping.field == empty.field )
        if(mapping) return mapping;
        return empty;
      })

      console.log("this.potential_site.collection_handles", this.potential_site);

      this.collection_mappings = this.potential_site.collection_handles ? this.potential_site.collection_handles.map(collection_handle => {
        let empty = CategoryMapping.newEmpty("collection_handle", collection_handle);
        let mapping = this.category_mappings.find( mapping => mapping.value == empty.value && mapping.field == empty.field )
        if(mapping) return mapping;
        return empty;
      }) : [];
    },
    async importShopifyCollections__clicked(event){
      let get_more = true;
      let page_index = 0;
      let all_collections = [];
      while(get_more) {
        let collection_json = await fetch(this.site.api_url + "/collections.json?limit=250&page=" + page_index).then(response => response.json());
        console.log("collections", collection_json);
        all_collections.push(...collection_json.collections);

        page_index++;
        get_more = collection_json.collections.length >= 250;
      }

      this.potential_site.collection_handles = [...new Set(all_collections.filter(u => u.products_count > 0).map( u => u.handle).sort())];

      console.log(" this.potential_site.collection_handle",  this.potential_site.collection_handles)

      await this.potential_site.save();

      alert("Imported Collections");

      //this.$forceUpdate(); // Doesn't reload page
      window.location.reload();
    },

    async test__clicked(event){
     // console.log("category_mappings", this.potential_site.category_mappings);

      /* let ps = await ShopifyProduct.where("site_name", "==", "bassike");
       for(let p of ps){
         p.site_name = "Bassike";
         console.log("p", p.handle, p.site_name)
         await p.save();
       }*/
    }


  }
}
</script>

